import api from './api';

export const ttsService = {
  /**
   * Convert text to speech
   */
  async convert(text, voiceId, options = {}) {
    const response = await api.post('/tts/convert', {
      text,
      voice_id: voiceId,
      language: options.language || 'en',
      voice_cleaner: options.voiceCleaner || false,
      speed: options.speed || 1.0,
      pitch: options.pitch || 1.0,
    });
    return response.data;
  },

  /**
   * Get audio file URL (relative path for authenticated requests)
   */
  getAudioUrl(requestId) {
    const baseUrl = import.meta.env.VITE_API_URL || 'http://localhost:8000/api/v1';
    return `${baseUrl}/tts/audio/${requestId}`;
  },

  /**
   * Fetch audio as blob URL (with authentication)
   */
  async getAudioBlob(requestId) {
    const response = await api.get(`/tts/audio/${requestId}`, {
      responseType: 'blob',
    });
    return URL.createObjectURL(response.data);
  },

  /**
   * Get available voices
   */
  async getVoices(language = null) {
    const params = language ? { language } : {};
    const response = await api.get('/tts/voices', { params });
    return response.data;
  },

  /**
   * Get specific voice details
   */
  async getVoice(voiceId) {
    const response = await api.get(`/tts/voices/${voiceId}`);
    return response.data;
  },

  /**
   * Get supported languages for XTTS multilingual
   */
  async getLanguages() {
    const response = await api.get('/tts/languages');
    return response.data;
  },

  /**
   * Get configured AI text-generation models
   */
  async getTextModels() {
    const response = await api.get('/tts/text-models');
    return response.data;
  },

  /**
   * Generate text content with selected AI model
   */
  async generateText(prompt, options = {}) {
    const response = await api.post('/tts/generate-text', {
      prompt,
      model: options.model,
      max_tokens: options.max_tokens || 400,
      temperature: options.temperature ?? 0.7,
    });
    return response.data;
  },

  /**
   * Get TTS history
   */
  async getHistory(page = 1, perPage = 20) {
    const response = await api.get('/tts/history', {
      params: { page, per_page: perPage },
    });
    return response.data;
  },

  /**
   * Get voice preview as blob URL (cached on server)
   */
  async getVoicePreview(voiceId) {
    const response = await api.get(`/tts/voices/${voiceId}/preview`, {
      responseType: 'blob',
    });
    return URL.createObjectURL(response.data);
  },

  /**
   * Delete TTS record
   */
  async deleteRecord(requestId) {
    const response = await api.delete(`/tts/history/${requestId}`);
    return response.data;
  },
};

export default ttsService;
